import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const getSvg = (iconColor: string) => `<path
d="M12 5.66406L12.1875 5.73438L17.625 7.79688L18 7.9375V8.3125V14.5V14.875L17.6484 15.0391L12.2109 17.2891L12 17.3594L11.7656 17.2891L6.32812 15.0391L6 14.875V14.5V8.3125V7.9375L6.35156 7.79688L11.7891 5.73438L12 5.66406ZM7.125 14.125L11.4375 15.9297V11.1484L7.125 9.46094V14.125ZM12.5625 15.9297L16.875 14.125V9.46094L12.5625 11.1484V15.9297ZM12 6.85938L7.73438 8.47656L12 10.1641L16.2656 8.47656L12 6.85938Z"
fill="${iconColor}"
/>`;

const designElement: DesignElementBase = {
  tags: ["preset"],
  iconColor: "",
  iconBackgroundColor: "",
  getIcon(options) {
    const iconColor =
      options?.iconColor || this.iconColor || options?.borderColor || "#7081FF";
    return createIcon(
      getSvg(iconColor),
      options?.iconBackgroundColor || this.iconBackgroundColor || "",
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
